var map = {
	"./nav-activity-active.svg": "d31f",
	"./nav-activity.svg": "a65c",
	"./nav-chat-active.svg": "4dbc",
	"./nav-chat.svg": "dbfc",
	"./nav-course-active.svg": "fe14",
	"./nav-course.svg": "081f",
	"./nav-evaluate-active.svg": "8dc3",
	"./nav-evaluate.svg": "d400",
	"./nav-note-active.svg": "56e9",
	"./nav-note.svg": "7548",
	"./nav-timetable-active.svg": "a0a3",
	"./nav-timetable.svg": "1917",
	"./nav-typical-active.svg": "4c7f",
	"./nav-typical.svg": "6559"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a08a";